const systemConfig = {
  isMFB: false,
  sytemName: 'JOINTAT_PENG'
}
// const systemConfig = {
//   isMFB: true,
//   sytemName: ''
// }
export default {
  systemConfig
}
